import React from 'react';
import {DataRow, DataRowKind} from '../../../components';
import {DataContainer} from './DataContainer';

type Props = {
  title: string;
  data?: string | number | boolean;
  kind?: DataRowKind;
  disabled: boolean;
  onPress?: (data: string | number | boolean) => void;
};

export const DataDisplay: React.FC<Props> = ({
  title,
  data,
  kind = 'Readonly',
  disabled,
  onPress,
}) => {
  return (
    <DataContainer>
      <DataRow
        label={title}
        data={data}
        onPress={onPress}
        kind={kind}
        disabled={disabled}
      />
    </DataContainer>
  );
};
